// extracted by mini-css-extract-plugin
export var border = "v_bQ";
export var btnMono = "v_bP";
export var header = "v_z";
export var item = "v_s";
export var itemActive = "v_bN";
export var menu = "v_R";